// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"25":"91cfe006","113":"926d91a1","210":"31246e46","523":"1c8bb307"}[chunkId] + ".chunk.css";
};